import React from 'react';
import CustomerMyBusinessByCustomerDetail from './CustomerMyBusinessByCustomerDetail';
import { CRM_COMM_PAGE_MY_ACQUISITION_BY_CUSTOMER_DETAIL_ACQUISITIONS } from '../../utils/crmCommunicationTableColumns';

export default function CustomerMyAcquisitionByCustomerDetail(props) {
  return (
    <CustomerMyBusinessByCustomerDetail
      {...props}
      mode="acquisitions"
      listEndpointBase="/api/customer_evaluations/my_acquisitions/by_customer"
      embeddedListPageKey={CRM_COMM_PAGE_MY_ACQUISITION_BY_CUSTOMER_DETAIL_ACQUISITIONS}
    />
  );
}
